import { createTheme, responsiveFontSizes } from "@mui/material/styles";
let theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0a1c4e",
    },
    background: {
      default: "#e3e3e3",
    },
    secondary: {
      main: "#fccd00",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
      variants: [
        {
          props: { variant: "contained" },
          style: {
            borderRadius: "10px",
          },
        },
      ],
    },

    MuiTextField: {
      defaultProps: {
        autoComplete: "off",
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          paddingLeft: "3px !important",
          paddingRight: "3px !important",
        },

        paper: {
          borderRadius: "10px !important",
          backgroundColor: "#e3e3e3 !important",
          overflow: "hidden",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderRadius: "10px",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "10px !important",
          backgroundColor: "#e3e3e3",
          overflow: "hidden",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        gutters: {
          color: "#187ed1",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: "#e3e3e3",
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
